// extracted by mini-css-extract-plugin
module.exports = {"redesignedFont":"styles-module-redesignedFont--zbFRG","highlightedTextColor":"styles-module-highlightedTextColor--J1fKj","capitalise":"styles-module-capitalise--mpDvu"};